import HOSelectChanges from './directives/HOSelectChanges';
import HOFlow from './directives/HOFlow';
import HOCoverages from './directives/HOCoverages';
import HOCoveragesEdit from './directives/HOCoveragesEdit';
import HOPolicyChanges from './directives/HOPolicyChanges';
import HOMortgagee from './directives/HOMortgagee';
import HOAdditionalInterestsEdit from './directives/HOAdditionalInterestsEdit';
import HOValuables from './directives/HOValuables';
import HOScheduledPropertiesEdit from './directives/HOScheduledPropertiesEdit';
import HOEditScheduledProperty from './directives/HOEditScheduledProperty';
import PolicyChange from 'edge/endorsement/common/models/PolicyChange';
import 'edge/platform/widgets/modal/module';
import 'edge/platform/widgets/inputs/module';
import 'edge/platform/widgets/loading/module';
import 'gw-portals-viewmodel-angular/aspects/module';
import 'edge/platform/widgets/basicinputs/module';
import 'edge/platform/flow/module';
import 'edge/platform/widgets/wizard/module';
import 'portalConfig';

export default angular.module('edge.endorsement.ho.app', ['portal.config', 'edge.platform.base', 'edge.platform.widgets.inputs', 'edge.platform.widgets.loadingMsg', 'edge.platform.widgets.modal', 'gw-portals-viewmodel-angular.aspects', 'edge.platform.widgets.basicinputs', 'edge.platform.flow', 'edge.platform.widgets.wizard']).directive('gwEndorsementHoSelectChanges', HOSelectChanges).directive('gwEndorsementHoFlow', HOFlow).directive('gwEndorsementHoMortgagee', HOMortgagee).directive('gwEndorsementHoAdditionalInterestsEdit', HOAdditionalInterestsEdit).directive('gwEndorsementHoValuables', HOValuables).directive('gwEndorsementHoScheduledPropertiesEdit', HOScheduledPropertiesEdit).directive('gwEndorsementHoCoverages', HOCoverages).directive('gwEndorsementHoCoveragesEdit', HOCoveragesEdit).directive('gwEndorsementHoPolicyChanges', HOPolicyChanges).directive('gwEndorsementEditScheduledProperty', HOEditScheduledProperty).config(['EventHubProvider', function (EventHubProvider) {
    EventHubProvider.registerTransformer({
        source: {
            category: 'tracking',
            eventName: 'serverCall'
        },
        target: {
            category: 'tracking',
            eventName: 'journey'
        },
        transformer: function transformer(payload, send) {
            if (!payload.success) return;
            if (payload.path === 'policychange/policychange' && payload.method === 'bind') {
                var jsonResponse = payload.response;
                var change = new PolicyChange(jsonResponse.policyChange);

                change.history.filter(function (h) {
                    return h.entityType === 'mortgagee';
                }).forEach(function (h) {
                    send({
                        eventName: 'Policy Changed - Mortgagee ' + h.action,
                        accountNumber: change.baseData.accountNumber,
                        policyNumber: change.policyNumber,
                        productCode: change.baseData.productCode,
                        mortgagee: h.action !== 'removed' ? {
                            name: h.entity.policyAdditionalInterest.displayName,
                            effectiveDate: h.effectiveDate,
                            address: h.entity.policyAdditionalInterest.primaryAddress.displayName
                        } : h.itemName
                    });
                });

                change.history.filter(function (h) {
                    return h.entityType === 'scheduledProperty';
                }).forEach(function (h) {
                    send({
                        eventName: 'Policy Changed - Valuable ' + h.action,
                        accountNumber: change.baseData.accountNumber,
                        policyNumber: change.policyNumber,
                        productCode: change.baseData.productCode,
                        scheduledProperty: h.action !== 'removed' ? {
                            type: h.entityType,
                            description: h.itemName
                        } : h.itemName
                    });
                });
            }
        }
    });
}]);


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=endorsement-products&equals=Homeowners!./common/js/src/edge/endorsement/ho/app.js
// module id = 441
// module chunks = 0